import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { SVGPathMap } from '@app/_helpers/constants';

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.scss']
})
export class NewUserComponent implements OnInit {

    utrade_logo = SVGPathMap.utrade_logo;

    constructor(
      private dialogRef: MatDialogRef<NewUserComponent>,
      private router: Router,
      private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit(): void {
    }

    close(): void{
      const queryParams = {...this.activatedRoute.snapshot.queryParams};
      queryParams.signup = null;
      this.router.navigate(
        [],
        {
          relativeTo: this.activatedRoute,
          queryParams,
          queryParamsHandling: 'merge',
          replaceUrl: true
        }
      )
      this.dialogRef.close();
    }

}
